import { render, staticRenderFns } from "./BasePageRender.vue?vue&type=template&id=0716a4d3&"
import script from "./BasePageRender.vue?vue&type=script&lang=js&"
export * from "./BasePageRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0716a4d3')) {
      api.createRecord('0716a4d3', component.options)
    } else {
      api.reload('0716a4d3', component.options)
    }
    module.hot.accept("./BasePageRender.vue?vue&type=template&id=0716a4d3&", function () {
      api.rerender('0716a4d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BasePageRender.vue"
export default component.exports